import React from 'react';
import { Box, Typography } from '@material-ui/core';
import Info from '@material-ui/icons/Info';
import './styles/hintCard.css';

interface HintCardProps {
  hintTitle: string;
  hintText: string;
  className?: string;
  style?: React.CSSProperties;
}
export default function HintCard({
  hintTitle,
  hintText,
  className,
  style,
}: HintCardProps) {
  return (
    <Box
      component="aside"
      className={`hint-box ${className || ''}`}
      role="complementary"
      style={style}
    >
      <Info className="hint-icon" aria-hidden="true" />
      <Box className="hint-content">
        <Typography className="hint-title">{hintTitle}</Typography>
        <Typography className="hint-text">{hintText}</Typography>
      </Box>
    </Box>
  );
}
